import { call, put, takeLatest } from 'redux-saga/effects'
import { select } from '@redux-saga/core/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IAttachment, IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { DocumentScannerConstants } from '../store/documentScanner.constants'
import { IScannedDocument } from '../store/documentScanner.types'
import { setDisableScanButton, setDocumentAttachments } from '../store/documentScanner.actions'
import { getMaximumDocumentAttachments } from '../store/documentScanner.reducer'

export function* getDocumentAttachments() {
  const pcrId: string = yield select(getPcrIdSelector)

  if (!pcrId) {
    return
  }
  try {
    const serviceId: string = yield select(getServiceIdSelector)
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrId)

    if (pcrDoc._scannedDocumentAttachments) {
      const scannedDocuments = pcrDoc._scannedDocumentAttachments.map((attachment: IAttachment) => {
        const scannedDocument: IScannedDocument = {
          id: attachment.id || '',
          imageSource: attachment.data,
          name: attachment.name || '',
          category: attachment.category || null,
        }

        return scannedDocument
      })

      if (pcrDoc._scannedDocumentAttachments.length < getMaximumDocumentAttachments()) {
        yield put(setDisableScanButton(false))
      }

      yield put(setDocumentAttachments(scannedDocuments))
    } else {
      yield put(setDocumentAttachments([]))
      yield put(setDisableScanButton(false))
    }
  } catch (e) {
    yield put(throwPcrException(`getDocumentAttachments() error: ${e}`))
  }
}

export function* getDocumentAttachmentsSaga() {
  yield takeLatest([DocumentScannerConstants.GET_DOCUMENT_ATTACHMENTS], performWithMutexHOG, getDocumentAttachments)
}
